import { render, staticRenderFns } from "./practitioner.vue?vue&type=template&id=fe1ce7a8&"
import script from "./practitioner.vue?vue&type=script&lang=ts&"
export * from "./practitioner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports